import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { TermsColumnsService } from '../../../services';
import { Term } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-post-details',
  templateUrl: './term-details.component.html',
  styleUrls: ['./term-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class TermDetailsComponent implements OnInit {

  public term: Term = {};
  public columns: Column[] = [];

  constructor(
    private router: Router,
    private dynamicDialogConfig: DynamicDialogConfig,
    private termsColumnsService: TermsColumnsService,
  ) { }

  ngOnInit(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.post !== 'undefined') {
      this.term = this.dynamicDialogConfig.data.post;
    }
    this.columns = this.termsColumnsService.getColumns();

    for (let i = 0; i <= this.columns.length; i++) {
      if (this.columns[i].field === "actions") {
        this.columns.splice(i, 1);
      }
    }
  }


}
@Component({
  selector: 'app-post-details',
  templateUrl: './term-details.component.html',
  styleUrls: ['./term-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogTermDetailsComponent extends TermDetailsComponent {
}

